"use strict";

exports.__esModule = true;
exports.default = has;
function has(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}